import React from "react";
import {BrowserRouter} from "react-router-dom"; // Routes, Route, Link,

/* Components ---------------------------*/
import Routing from './Routing';
import Layout from './layout/Layout';

const App = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Routing />
            </Layout>
        </BrowserRouter>
    );
}

export default App;
